import React from 'react'
import { withEditTransaction } from 'tennders-transactions/hocs/withEditTransaction'
import IconEdit from '../../../../public/icons/icon-edit.svg'

const RowEditAction = () => (
  <IconEdit />
)

export default withEditTransaction(RowEditAction)
